module.exports = __webpack_public_path__ + "static/media/window3.d5f1d779.jpeg";